import * as constants from './constants';

export const setMetadata = (metadata) => ({
  type: constants.SET_METADATA,
  payload: metadata,
});
